var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(Object.assign({}, {paddingBottom: ("calc(" + (1 / this.aspectRatio) + " * 100%)"),
  width: '100%'},
  _vm.backgroundStyle))})}
var staticRenderFns = []

export { render, staticRenderFns }